import { gatewayApiAgent } from 'common/api/apiAgents';
import { Merchant } from 'common/api-types/director';

export async function fetchMerchantOptions() {
  return gatewayApiAgent
    .get<Merchant[]>('/director/public/v1/current-user/merchants')
    .then((response) => response.data)
    .catch((err) => {
      console.error(err.message);
      return undefined;
    });
}
